import { z } from 'zod';
import { CHANGE_KINDS } from '../changelog.js';
import { IsoDate } from './common.js';

/**
 * Lot BA « Nouveautés » : le journal des versions servi à l'appli (`GET /api/changelog`), lu dans CHANGELOG.md.
 * Seules les versions visibles sont servies (ni « À venir », ni les versions techniques).
 */

export const ChangeKind = z.enum(CHANGE_KINDS);
export type ChangeKind = z.infer<typeof ChangeKind>;

/** Version MAJEUR.MINEUR.CORRECTIF. */
export const AppVersion = z.string().regex(/^\d+\.\d+\.\d+$/, 'Version attendue au format 1.2.3');

export const ChangelogChange = z.object({ kind: ChangeKind, text: z.string() });
export type ChangelogChange = z.infer<typeof ChangelogChange>;

/**
 * Un écran et ses lignes. `screen` reste une chaîne libre dans le contrat : une appli ouverte depuis une version
 * plus ancienne lit encore le journal d'un serveur qui connaît un nouvel écran (ex. « Sous-traitants »).
 */
export const ChangelogScreen = z.object({ screen: z.string(), changes: z.array(ChangelogChange) });
export type ChangelogScreen = z.infer<typeof ChangelogScreen>;

export const ChangelogVersion = z.object({
  version: AppVersion,
  date: IsoDate,
  screens: z.array(ChangelogScreen),
});
export type ChangelogVersion = z.infer<typeof ChangelogVersion>;

/** `GET /api/changelog` : la version du serveur et les versions visibles, la plus récente d'abord. */
export const Changelog = z.object({
  current: z.string(),
  versions: z.array(ChangelogVersion),
});
export type Changelog = z.infer<typeof Changelog>;
